/**
 * Nav component
 * 
 */

import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

// Functions

import Helpers from '../../utils/functions/helpers';
import Event from '../../utils/functions/analytics';

// Javascript

import DrawerJs from '../../assets/js/drawer';

class Nav extends Component {

	constructor(props) {

		super(props);

		this.state = {

            drawer: 'closed'
        };
		
    	this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {

		event.preventDefault();

		const target = event.currentTarget.getAttribute('href');
		const navigate = () => { this.props.history.push(target); }

		if (document.body.classList.contains('drawer-visible')) {

			const toggle = document.body.getAttribute('data-toggle');
			const panel = document.getElementById(toggle);

			setTimeout(() => { DrawerJs.transition(panel, 'close', navigate) }, 100);
		}
		else {

			navigate();
		}

		Event.navigation({ action: 'link', label: event.target.text });
	}
	
	render() {

		const { nav, uid, className } = this.props;
		
		const menu = nav && nav.find( menu => menu.uid === uid );
		const name = 'nav ' + className;

		if (menu) {

			const { menu_links: links, show_title: show, title } = menu.data;

			return (

				<nav className="menu">

					{ show.toLowerCase() === 'yes' && <h5>{title}</h5> }

	                <ul className={name}>
	                	{	

	                		links.map((item, i) => {
	                			
	                			const url = Helpers.linkResolver(item.link);
	                			const target = item.link.link_type === 'Document' ? {} : { target: '_blank' };
	                			
	                			if (url === undefined) {

	                				return null;
	                			}
	                			else {

	                				return <li key={i} className="nav-item"><NavLink exact to={url} {...target} className="nav-link" onClick={this.handleClick}>{item.label[0].text}</NavLink></li>;
	                			}
	                		})
	                	}
	                </ul>
	            </nav>
			);
		}
		else {

			return null;
		}
	}
}

export default withRouter(Nav)



// WEBPACK FOOTER //
// ./src/components/nav/nav.js